export default {
  API_URL: process.env.AUTH_API_URL,
  SITES_API_URL: process.env.SITES_API_URL,
  GOOGLE_CLIENT_ID: process.env.GOOGLE_CLIENT_ID,
}



// WEBPACK FOOTER //
// ./src/config.js